<template>
<v-dialog class="dialogDefault" v-model="dialog" max-width="290">
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>{{message}}</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red lighten-1" dark @click="(typeof ok === 'function' ? ok() : ok); dialog = false">OK</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
	name: 'dialogDefault',
	props: {
		show: true,
		title: '',
		message: '',
		ok: ''
	},
	data() {
		return {
			dialog: this.$props.show
		}
	},
	watch: {
		show: function (newVal) { // newVal, oldVal
			this.dialog = newVal;
		},
		title: function (newVal) { // watch it
			this.title = newVal;
		},
		message: function (newVal) { // watch it
			this.message = newVal;
		},
		dialog: function (newVal) {
			if (newVal === false) {
				this.$emit('close')
			}
		},
	},
	mounted: function () {


	}
}
</script>

<style lang="scss" scoped>
.dialog {}
</style>
